var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"headermenu",class:{ disabled: _vm.disabled },attrs:{"tabindex":"9999"}},[_c('b-icon',{attrs:{"icon":_vm.icon}}),_vm._v(" "),_c('span',{staticClass:"hidden-on-small-screens"},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]),_vm._v(" "),(!_vm.disabled)?_c('div',[_vm._t("default")],2):_vm._e()],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a056fe4","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toolbar/DropDownMenu.vue
// module id = 1585
// module chunks = 1